import { useMemo } from "react";
import ReactConfetti from "react-confetti";
import useWindowSize from "react-use/lib/useWindowSize";

const ConfettiEffect = () => {
  const { width, height } = useWindowSize();

  return (
    <>
      {width > 0 && height > 0 && (
        <ReactConfetti
          colors={["#a67c00", "#bf9b30", "#ffbf00", "#ffcf40", "#ffdc73"]}
          gravity={0.2}
          height={1000}
          initialVelocityY={-13}
          recycle={false}
          run={true}
          tweenDuration={5000}
          width={2000}
        />
      )}
    </>
  );
};

export default ConfettiEffect;
